import { axios } from '../../utilities/axiosClient'
import { Top } from '../../types/Top'

export const getTop = (param: string | null): Promise<Top> => {
  return param ? axios.get(`/api/top?rp=${param}`) : axios.get('/api/top')
}
